import { doc, getDoc, setDoc, serverTimestamp } from "firebase/firestore";
import { db } from "../firebase/config";
import type {
  DailySymptoms,
  RecoveryDailyLog,
  SymptomAlertsSummary,
} from "../types/recovery";

const RECOVERY_PROGRAMME_ID = "physical_wellbeing_6w";

export const getRecoveryDailyLogRef = (userId: string, dateId: string) =>
  doc(db, "users", userId, "recoveryDailyLogs", dateId);

export const getRecoveryDailyLog = async (
  userId: string,
  dateId: string,
): Promise<RecoveryDailyLog | null> => {
  try {
    const ref = getRecoveryDailyLogRef(userId, dateId);
    const snap = await getDoc(ref);
    return snap.exists() ? (snap.data() as RecoveryDailyLog) : null;
  } catch (err) {
    console.error('getRecoveryDailyLog failed:', err);
    return null;
  }
};

export const buildRecoveryDailyLogBase = (
  userId: string,
  dateId: string,
  weekNumber: number,
): Partial<RecoveryDailyLog> => ({
  userId,
  dateId,
  date: serverTimestamp(),
  programmeId: RECOVERY_PROGRAMME_ID,
  weekNumber,
  updatedAt: serverTimestamp(),
  createdAt: serverTimestamp(),
});

export const saveRecoveryDailyLog = async (
  userId: string,
  dateId: string,
  payload: Partial<RecoveryDailyLog>,
): Promise<void> => {
  try {
    const ref = getRecoveryDailyLogRef(userId, dateId);
    await setDoc(ref, payload, { merge: true });
  } catch (err) {
    console.error('saveRecoveryDailyLog failed:', err);
    throw err;
  }
};


export const getRecoverySymptomsForDay = async (
  userId: string,
  dateId: string,
): Promise<DailySymptoms> => {
  const existing = await getRecoveryDailyLog(userId, dateId);
  return existing?.symptoms ?? {};
};

export const saveRecoverySymptomsCheckin = async (
  userId: string,
  dateId: string,
  weekNumber: number,
  symptoms: DailySymptoms,
  symptomAlerts: SymptomAlertsSummary,
): Promise<void> => {
  const existing = await getRecoveryDailyLog(userId, dateId);

  const finalSymptoms: DailySymptoms = {
    ...symptoms,
    ...(existing?.symptoms?.vaginalBleeding
      ? { vaginalBleeding: existing.symptoms.vaginalBleeding }
      : {}),
  };

  await saveRecoveryDailyLog(userId, dateId, {
    ...buildRecoveryDailyLogBase(userId, dateId, weekNumber),
    symptoms: finalSymptoms,
    symptomAlerts,
  });
};
